import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4135_3113)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.25241 2.58579C1.62749 2.21071 2.13619 2 2.66663 2H7.33329C7.70148 2 7.99996 2.29848 7.99996 2.66667C7.99996 3.03486 7.70148 3.33333 7.33329 3.33333H2.66663C2.48981 3.33333 2.32025 3.40357 2.19522 3.5286C2.0702 3.65362 1.99996 3.82319 1.99996 4V13.3333C1.99996 13.5101 2.0702 13.6797 2.19522 13.8047C2.32025 13.9298 2.48982 14 2.66663 14H12C12.1768 14 12.3463 13.9298 12.4714 13.8047C12.5964 13.6797 12.6666 13.5101 12.6666 13.3333V8.66667C12.6666 8.29848 12.9651 8 13.3333 8C13.7015 8 14 8.29848 14 8.66667V13.3333C14 13.8638 13.7892 14.3725 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H2.66663C2.13619 15.3333 1.62748 15.1226 1.25241 14.7475C0.87734 14.3725 0.666626 13.8638 0.666626 13.3333V4C0.666626 3.46957 0.87734 2.96086 1.25241 2.58579Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.3333 1.91903C13.135 1.91903 12.9449 1.99779 12.8047 2.13798L6.60195 8.34074L6.24955 9.75033L7.65914 9.39793L13.8619 3.19517C14.0021 3.05498 14.0809 2.86483 14.0809 2.66657C14.0809 2.46831 14.0021 2.27817 13.8619 2.13798C13.7217 1.99779 13.5316 1.91903 13.3333 1.91903ZM11.8619 1.19517C12.2521 0.804928 12.7814 0.585693 13.3333 0.585693C13.8852 0.585693 14.4145 0.804928 14.8047 1.19517C15.195 1.58541 15.4142 2.11469 15.4142 2.66657C15.4142 3.21846 15.195 3.74774 14.8047 4.13798L8.47138 10.4713C8.38594 10.5568 8.27889 10.6174 8.16166 10.6467L5.495 11.3133C5.26781 11.3701 5.02749 11.3036 4.8619 11.138C4.69632 10.9724 4.62975 10.7321 4.68655 10.5049L5.35321 7.83822C5.38252 7.72099 5.44313 7.61394 5.52857 7.5285L11.8619 1.19517Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4135_3113",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "currentColor"
		})
	}) })]
});
export default SvgEdit;
